import Logo from "components/Logo/Logo";
import styled from "styled-components";

export { TooltipContent } from "components/Filters/Filters.styles";

export const FilterLogo = styled(Logo)`
  margin-right: 10px;
`;
